import http from "axiosSetup";
import type { OneRepMax, OneRepMaxesCreate, OneRepMaxesUpdate, OneRepMaxParams, OneRepMaxValue } from "types/onerepmax";

class OneRepMaxService {
  static async getByAthleteIds(exerciseId: string, athleteIds: string[], params?: { mostRecent?: boolean }) {
    return http
      .post<OneRepMax[]>("/athletes/one-rep-maxes/exercise", { athleteIds, exerciseId }, { params })
      .then((response) => response.data);
  }

  static async updateByAthleteIds(oneRepMaxes: OneRepMaxesUpdate[]) {
    return http
      .post<Pick<OneRepMaxValue, "id">[]>("/athletes/one-rep-maxes", oneRepMaxes)
      .then((response) => response.data);
  }

  static async deleteByOneRepMaxId(athleteId: string, oneRepMaxId: string) {
    return http.delete(`/athletes/${athleteId}/one-rep-maxes/${oneRepMaxId}`).then((response) => response.data);
  }

  static async getByAthleteId(athleteId: string, params: OneRepMaxParams) {
    return http
      .get<OneRepMaxValue[]>(`/athletes/${athleteId}/one-rep-maxes`, { params, paramsSerializer: { indexes: null } })
      .then((response) => response.data);
  }

  static async createMany(oneRepMaxes: OneRepMaxesCreate[]) {
    return http
      .post<Pick<OneRepMaxValue, "id">[]>("/athletes/one-rep-maxes", oneRepMaxes)
      .then((response) => response.data);
  }
}

export default OneRepMaxService;
